export const ALL_STAFF_BUTTON_TEXT = 'Prepare for All-Staff'
export const EDIT_BUTTON_TEST_ID = 'Edit Goals'
export const FAMILIES_BUTTON_TEXT = 'Inform Families'
export const GET_STARTED_BUTTON_TEXT = 'Get Started'
export const GET_STARTED_BUTTON_TEST_ID = 'get-started-button'
export const GOALS_TEXT = 'Add Goals'
export const HEADER_TEXT_DEFAULT = 'Set Up for 2026-27'
export const HEADER_TEXT_RECENT_ACTIVITIES = 'School Recent Activities'
export const HEADER_TEXT_SUMMARY = 'Setup Complete!'
export const IMPLEMENTATION_APPROACH_TEXT = 'Choose Approach'
export const MARK_COMPLETE_BUTTON_TEXT = 'Mark Complete'
export const PAGE_CONTENT_TEST_ID = 'playbook-steps-page-content'
export const PLAYBOOK_STEPS_PLAN_WRAPPER_TEST_ID = 'playbook-steps-plan-wrapper'
export const PLAYBOOK_STEPS_MONITOR_WRAPPER_TEST_ID =
  'playbook-steps-monitor-wrapper'
export const PLAYBOOK_STEPS_RECENT_ACTIVITIES_WRAPPER_TEST_ID =
  'playbook-steps-recent-activities-wrapper'
export const PURPOSE_TEXT = 'Add Your Purpose'
export const RESUME_BUTTON_TEXT = 'Resume'
export const SEE_CLASSES_BUTTON_TEXT = 'See Classes'
export const SUMMARY_LINK_TEXT = 'View 2026-27 Setup'
export const DATE_TEST_FLAG = 'BTS-2026_playbookDateTest'
export const BTS_2026_FLAG = 'LEARN-BTS-Playbook-2026'
export const RECENT_ACTIVITIES_FLAG = 'feature_LEARN-28194-recent-activities'
export const GOAL_NOT_SET_WARNING_PREFIX = 'No goal set.'
export const GOAL_NOT_SET_ADD_GOAL_LINK_TEXT = 'Add a goal now.'
export const NO_SCHOOLWIDE_GOAL_MESSAGE = 'No schoolwide goal'
export const USERS_STAT_LABEL = 'Users'
export const USERS_WITHOUT_CLASSES_STAT_LABEL = 'without classes'
export const USERS_WITHOUT_ACCOUNTS_STAT_LABEL = 'pending'
export const MANAGE_USERS_LINK_TEXT = 'Manage Users'
export const USER_MANAGEMENT_PATH = '/user-management'
export const VIEW_STAFF_BUTTON_TEXT = 'View Staff'
export const VIEW_CLASSES_LINK_TEXT = 'View Classes'
export const RECENT_ACTIVITIES_ALL_CLASSES_LABEL = 'All classes'
export const RECENT_ACTIVITIES_ALL_CLASSES_DESCRIPTION =
  'Have started teaching lessons'
export const RECENT_ACTIVITIES_NO_LESSON_DESCRIPTION =
  "Haven't completed a lesson yet"
export const RECENT_ACTIVITIES_LESSON_14_DAYS_DESCRIPTION =
  'Marked a lesson done in the past 14 days'
export const RECENT_ACTIVITIES_STAFF_LOGIN_DESCRIPTION =
  'Logged in during the past 7 days'
export const RECENT_ACTIVITIES_STACKED_MEDIA =
  'screen and (min-width: 993px) and (max-width: 1168px), screen and (max-width: 512px)'
